import Api from '@api/shou_xie/themeChose'
import { getSessionMerchantInfo, isUltimate } from '@merchant-backend/util'
import {
  getMerchantInfo,
  getProTitle,
  isDispatchOrderMerchant,
  isHotelMerchant
} from '@util'
import { Modal } from 'hljd'
import { action, observable } from 'mobx'

class Store {
  //预览
  @observable qrCote = [false, false, false, false, false, false]
  @action
  showQrCote = index => () => {
    this.qrCote[index] = true
  }
  @action
  hideQrCote = index => () => {
    this.qrCote[index] = false
  }
  @action
  onCancel = () => {
    this.modalIf.isShow = false
  }
  @observable
  modalIf = {
    type: '',
    isShow: false,
    btn1: '',
    btn2: '',
    content: ''
  }
  @observable channel = {}
  @action
  choseThemeFn = index => async () => {
    // 酒店派单商家直接用
    if ((isHotelMerchant() && isDispatchOrderMerchant()) || isUltimate()) {
      this.chooseTheme(index)
      return
    }

    let obj = getSessionMerchantInfo()
    if (
      obj.examine != 1 ||
      ((obj.certify.status != 3 &&
        obj.is_new == 1 &&
        obj.kind != 1 &&
        obj.kind != 2) ||
        (obj.is_opened_trade == false && obj.is_new == '0'))
    ) {
      this.modalIf = {
        type: 1,
        isShow: true,
        btn1: '确定',
        btn2: '',
        content: '您尚未完成店铺审核或实名认证,暂时无法使用此模板！'
      }
      return
    }

    if (!isUltimate()) {
      this.modalIf = {
        type: 2,
        isShow: true,
        btn1: '关闭',
        btn2: '了解详情',
        content: `无法使用此功能，请升级至${getProTitle()}！`
      }
      return
    }

    this.chooseTheme(index)
  }

  chooseTheme = async index => {
    const { success } = await Api.choseThemeApi({ id: index })
    if (success) {
      Modal.success({
        content: '您的移动端店铺已使用此模板',
        okText: '好的',
        title: '设置成功'
      })
      this.decorationFn()
    }
  }

  @observable theme = ''
  decorationFn = async () => {
    let {
      data: { theme },
      success
    } = await Api.decorationApi({ merchant_id: getMerchantInfo().id })
    if (success) {
      this.theme = theme
    }
  }
}
export default new Store()
